/*
 * Animação de abertura do mega menu glass (top-to-bottom) com GSAP.
 * O painel "desenrola" de cima para baixo (clip-path) enquanto as colunas
 * entram em cascata (stagger). Progressive enhancement: só ativa quando o
 * GSAP está disponível; sem ele, o CSS [open] exibe o painel normalmente.
 */
(function () {
  function init() {
    var gsap = window.gsap;
    if (!gsap) return;

    var RADIUS = 16;
    var CLIPPED = 'inset(0% 0% 100% 0% round ' + RADIUS + 'px)';
    var REVEALED = 'inset(0% 0% 0% 0% round ' + RADIUS + 'px)';

    // Sinaliza ao CSS que o GSAP assumiu o controle (mantém o painel "clipado"
    // por padrão para não haver flash antes da animação rodar).
    document.documentElement.classList.add('tp-mm--gsap');

    var panels = document.querySelectorAll('.tp-mm__details');

    panels.forEach(function (det) {
      var content = det.querySelector('.tp-mm__content');
      if (!content) return;

      // cascata limpa pelas colunas (sem aninhar cards/promo, p/ não
      // compor opacidade do pai com a do filho)
      var items = content.querySelectorAll('.tp-mm__col');
      var tween;

      function openAnim() {
        if (tween) tween.kill();
        gsap.set(content, {
          visibility: 'visible',
          opacity: 1,
          clipPath: CLIPPED,
          webkitClipPath: CLIPPED,
          willChange: 'clip-path'
        });
        gsap.set(items, { opacity: 0, y: 16 });

        tween = gsap.timeline({ defaults: { ease: 'power3.out' } });
        tween
          .to(content, {
            clipPath: REVEALED,
            webkitClipPath: REVEALED,
            duration: 0.5
          })
          .to(
            items,
            { opacity: 1, y: 0, duration: 0.45, stagger: 0.06 },
            '-=0.32'
          )
          // remove o clip ao final para não recortar a sombra do painel
          .set(content, { clipPath: 'none', webkitClipPath: 'none', willChange: 'auto' });
      }

      function closeAnim() {
        if (tween) tween.kill();
        tween = gsap.timeline({
          defaults: { ease: 'power2.in' },
          onComplete: function () {
            gsap.set(content, { clearProps: 'all' });
          }
        });
        tween.to(content, {
          opacity: 0,
          clipPath: CLIPPED,
          webkitClipPath: CLIPPED,
          duration: 0.3
        });
      }

      det.addEventListener('toggle', function () {
        if (det.open) {
          openAnim();
        } else {
          closeAnim();
        }
      });
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
